<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-item label="Date">
          <a-date-picker
            placeholder="Select Date"
            :disabled="true"
            :format="getDefaultDateFormat"
            v-decorator="[
              'tanggal',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.tanggal,
              },
            ]"
          />
        </a-form-item>
        <!-- <a-form-item label="Project Code">
          <a-input
            v-decorator="[
              'project_nm',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.project_nm,
              },
            ]"
          ></a-input>
        </a-form-item> -->
        <!-- <a-form-item label="Description">
          <a-input
            v-decorator="[
              'deskripsi',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.deskripsi,
              },
            ]"
          ></a-input>
        </a-form-item> -->
        <a-form-item label="Customer Name">
          <!-- <a-select
            v-decorator="[
              'customer_id',
              {
                rules: [
                  { required: true, message: 'Customer Name Required' },
                ],
                initialValue: initialData.informasi.customer_id,
              },
            ]"
            showSearch
            option-filter-prop="children" :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in listCustomer"
              :key="item.customer_id"
              :value="item.customer_id"
              >{{ item.customer_code }} - {{ item.customer_nm }}</a-select-option
            >
          </a-select> -->
          <a-input
            v-decorator="[
              'customer_nm',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.customer,
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Description">
          <a-textarea
            :rows="4"
            v-decorator="[
              'deskripsi',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.deskripsi,
              },
            ]"
          />
        </a-form-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <!-- <a-form-item label="Periode Development">
          <a-range-picker :placeholder="['Start Date', 'End Date']"
            v-decorator="[
              'periode',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.periode,
              },
            ]"
            :format="getDefaultDateFormat" allowClear />
        </a-form-item> -->
        <!-- <a-form-item label="Due Date"> -->
          <!-- <a-input
            v-decorator="[
              'due_date',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.due_date,
              },
            ]"
          ></a-input> -->
          <!-- <a-date-picker
            placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="[
              'due_date',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.due_date,
              },
            ]"
          />
        </a-form-item> -->
        <!-- <a-form-item label="Estimated Project Value">
          <a-input-number
            :max="999999999999"
            :min="0"
            class="m-width-full"
            v-decorator="[
              'estimate_project_val',
              {
                rules: [{ required: true },{validator: validRatherThenzero} ],
                initialValue: initialData.informasi.estimate_project_val,
              },
            ]"
          ></a-input-number>
        </a-form-item> -->
        <a-form-item label="Estimated Sales Value (IDR)">
          <!-- <a-input
            v-decorator="[
              'estimate_project_cost',
              {
                rules: [],
                initialValue: initialData.informasi.estimate_project_cost,
              },
            ]"
          ></a-input> -->
          <a-input-number
            :max="999999999999999"
            :min="0"
            @keydown="onlyNumber"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
            class="m-width-full"
            v-decorator="[
              'estimate_project_cost',
              {
                rules: [{ required: true },{validator: validRatherThenOrSamezero}],
                initialValue: initialData.informasi.estimate_project_cost,
              },
            ]"
          ></a-input-number>
        </a-form-item>
        <a-form-item label="Estimated Prospect Cost (IDR)">
          <!-- <a-input
            v-decorator="[
              'estimate_project_cost',
              {
                rules: [],
                initialValue: initialData.informasi.estimate_project_cost,
              },
            ]"
          ></a-input> -->
          <a-input-number
            :max="999999999999999"
            :min="0"
            @keydown="onlyNumber"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
            class="m-width-full"
            v-decorator="[
              'estimate_prospect_cost',
              {
                rules: [{ required: true },{validator: validRatherThenOrSamezero}],
                initialValue: initialData.informasi.estimate_prospect_cost,
              },
            ]"
          ></a-input-number>
        </a-form-item>
        <!-- <a-form-item label="Bid Reasoning">
          <a-input
            v-decorator="[
              'bid_reasoning',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.bid_reasoning,
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="UP/RFQ Number">
          <a-input
            v-decorator="[
              'up_rfq_no',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.up_rfq_no,
              },
            ]"
          ></a-input>
        </a-form-item> -->
        <!-- <a-form-item label="PIMPRO">
          <a-select
            showSearch
            allowClear
            optionFilterProp="children"
            :filterOption="filterOption"
            v-decorator="[
              'pimpro',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.pimpro,
              },
            ]">
              <a-select-option
                v-for="item in listBawahan"
                :key="item.tlc"
                :value="item.tlc"
                >{{ item.tlc }} - {{ item.nama }}</a-select-option
              >
            </a-select>
        </a-form-item>
        <a-form-item label="Executor Site">
          <a-select
            :disabled="mode === 'Edit' ? true : false"
            class="m-width-full"
            v-decorator="[
              'executor_site',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.executor_site,
              },
            ]"
          >
            <a-select-option value="Site Surabaya"
              >Site Surabaya</a-select-option
            >
            <a-select-option value="Site Jakarta">Site Jakarta</a-select-option>
          </a-select> -->
          <!-- <a-input
            v-decorator="[
              'executor_site',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.executor_site,
              },
            ]"
          ></a-input> -->
        <!-- </a-form-item> -->
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";
export default {
  name: "Informasi",
  props: {
    data: {},
    persetujuan: {},
    listCustomer: {},
    listBawahan: {},
    mode: String,
  },
  mixins: [GlobalMethod,],
  data() {
    return {
      activeProject: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getDefaultDateFormat","getAllKaryawan"]),
    initialData() {
      let informasi = {};
      let pimpinan = {};
      if (this.data === undefined || this.data.length <= 0) {
        informasi = {
          tanggal: moment(),
          deskripsi: "",
          customer_nm: "",
          periode: [null,null],
          due_date: "",
          special_requirment: "",
          estimate_project_val: "0",
          estimate_project_cost: "0",
          executor_site: "",
          pimpro: ""
        };
        return { informasi };
      } else {
        informasi = {
          tanggal: moment(this.data.create_dt),
          deskripsi: this.data.description || this.data.deskripsi,
          customer: this.data.customer || this.data.customer_nm,
          estimate_prospect_cost: this.data.est_biaya_prospek || this.data.estimate_prospect_cost,
          estimate_project_cost: this.data.est_nilai_penjualan || this.data.estimate_project_cost,
          note: this.data.note
        };
        return { informasi, pimpinan };
      }
    },
  },
  created() {
    this.$store.dispatch("FETCH_PRODUKRND");
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
  },
  methods: {
    moment,
    handleProject(value) {
      let filter = this.project.filter(
        (obj) =>
          obj.kode_project.toLowerCase().indexOf(value.toLowerCase()) >= 0
      );

      this.initialData.pimpinan.pimpro = filter[0].pimpro;
      this.initialData.pimpinan.bod = filter[0].bod;
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        // if(values.estimate_prospect_cost>values.estimate_project_cost){
        //   this.displayMessageValue("basic-error", "Estimated Prospect Cost Can't be over then Estimated Sales Value!");
        //   return;
        // }
        values.note = this.initialData.informasi.note
        // console.log(values)
        Event.$emit("ProspectNotifData", {
          informasi: values,
        });
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>

<style>
</style>